import React from "react";
import { TransportItem } from "../../types";
import { formatDate, formatTime, formatPrice } from "../../functions/Utils";
import { Card } from "react-bootstrap";
import { FaTriangleExclamation } from "react-icons/fa6";

const OfferCard = ({ offer }: { offer: TransportItem }) => {
  const imageUrl = offer?.cpd?.img.startsWith("http")
    ? offer.cpd.img
    : "https://www.vivanoda.com" + offer?.cpd?.img;

  return (
    <Card className="border-gray-300 p-0 mb-1">
      <div className="flight-card d-flex flex-row align-items-center p-3 my-2">
        <img
          style={{ maxWidth: "100px", maxHeight: "40px" }}
          src={offer?.cpd?.img}
          alt="logo"
          className="airline-logo me-3"
        />

        <div className="text-center me-4">
          <div className="fw-bold">{formatTime(offer.dep)}</div>
          <div className="text-muted small">{offer.nf}</div>
        </div>

        <div className="flex-grow-1 text-center px-2">
          <div className="flight-line d-flex align-items-center justify-content-center">
            <div className="line" />
            {Array(offer.ch)
              .fill(0)
              .map((change) => (
                <>
                  <div className="stop-icon"></div>
                  <div className="line" />
                </>
              ))}
          </div>
          <div className="text-muted small me-2">
            {Math.floor(offer.du / 60)}h {offer.du % 60}m
          </div>
        </div>

        <div className="text-center mx-4">
          <div className="fw-bold">{formatTime(offer.arr)}</div>
          <div className="text-muted small">{offer.nt}</div>
        </div>

        <div className="text-end ms-auto">
          <div className="text-secondary fw-bold fs-5">
            {formatPrice(offer.A, offer.C)}
          </div>
        </div>
      </div>

      <div className="d-flex px-2">
        {offer.availability && offer.availability < 10 && (
          <div className="flex-column p-1">
            <div className="badge bg-danger">
              <FaTriangleExclamation className="me-1" /> Plus que{" "}
              {offer.availability} places disponibles
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};

export default OfferCard;
